<template>
  <li class="icon-text-list-item">
    <fn-icon :icon="icon" />
    <div>
      <strong v-if="title">{{ title }}</strong>
      <template v-if="text">
        {{ text }}
      </template>
    </div>
  </li>
</template>

<script setup lang="ts">
export type IconTextListItemProps = {
  icon: Array<string> | string;
  text: string;
  title: string | undefined;
};

defineProps<IconTextListItemProps>();
</script>

<style lang="scss" scoped>
.icon-text-list-item {
  display: flex;
  flex-direction: row;
  list-style-type: none;
  margin-bottom: $pad;

  .icon {
    display: block;
    font-size: 24px;
    min-width: 1.96em;
  }

  strong {
    display: block;
  }
}
</style>
